<!-- BackTop.vue 回到顶部 -->
<template>
	<div class="scan-cart" @click="toScancartGoods" v-if="goodsList && goodsList.length>0">
		<img  class="img" :src="tabbar_cart_sel" alt="" srcset="">
		<span class="count">{{ cartNumber }}</span>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapActions } from 'vuex'
	import tabbar_cart_sel from '@/assets/image/tabbar-icon/tabbar_cart_sel@3x.png'

	export default {
		name: 'ScanCart',
		data() {
			return {
				tabbar_cart_sel:tabbar_cart_sel,
			}
		},
		computed: {
			...mapState({
				user:state => state.auth.user,
				scan_cartGoods: state => state.scancart.scan_cartGoods || [],
			}),
			goodsList(){
				let obj = this.scan_cartGoods[0] || {}
        return obj.goods || []
			},
			cartNumber(){
				let obj = this.scan_cartGoods[0] || {}
				let goods = obj.goods || []
				let number = 0
				for(let g of goods){
					number += g.amount
				}
				if (number > 0 && number < 100) {
					return number
				} else if (number >= 100) {
					return '99+';
				}
			}
		},
		activated(){
			if(this.user && this.user.id){
					this.fetchScreenCartList({operator_uid:this.user.id})
				}
		},
		created() {
			if(this.user && this.user.id){
				this.fetchScreenCartList({operator_uid:this.user.id})
			}
		},
		methods: {
			...mapMutations({
				clearScanSelectedCartGoods: 'clearScanSelectedCartGoods',
				scanCalculationAmount: 'scanCalculationAmount'
			}),
			...mapActions({
				fetchScreenCartList: 'fetchScreenCartList',
			}),
			toScancartGoods(){
				this.$router.push({ name: 'scancart', query: { type: 1 } });
			}
		}
	}
</script>

<style lang="scss" scope>
.scan-cart{
	position: absolute;
	right: 6vw;
	bottom: 5vh;
	z-index: 999;
	width: 42px;
	height: 42px;
	font-size: 26px;
	.img{
		width: 42px;
		height: 42px;
	}
	.count{
			position: relative;
			right: -16px;
			background: #EF3338;
			font-size: 14px;
			color: #ffffff;
			border-radius: 50%;
			width: 20px;
			line-height: 20px;
			height: 20px;
			font-weight: normal;
			text-align: center;
			top: -60px;
			display: inline-block;
	}
}
</style>



// WEBPACK FOOTER //
// src/page/home/child/ScanCart.vue